import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { TopTenHoldingResponse } from 'src/app/models/top-ten-holdings-response.model'

@Injectable({
  providedIn: 'root',
})
export class TopTenHoldingsService {
  public static readonly topTenHoldingsEndpoint = '/topTenHoldings'

  constructor(private readonly http: HttpClient) {}

  getTopTenHoldings(fundId: string): Observable<TopTenHoldingResponse> {
    return this.http.get<TopTenHoldingResponse>(
      `vmf/api/${fundId}`.concat(TopTenHoldingsService.topTenHoldingsEndpoint),
    )
  }
}
